/* eslint-disable no-throw-literal */
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import AuthContext from '../contexts/AuthContext';
import { AlertContext } from '../contexts/AlertContext';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { Storage } from 'aws-amplify';

const ProductAndroidAssetForm = ({ collection, productSKU, productImages, isActive }) => {
  const location = useLocation();
  const { authState } = useContext(AuthContext);
  const { dispatch } = useContext(AlertContext);
  const closeAlert = () => dispatch({ type: 'close' }); // HACK: needed to pass reducer dispatch() func
  const [activeCard, setActiveCard] = useState(
    authState.userPermissions.facecake ? 'refinements' : 'product-images'
  );
  const [productAndroidConfig, setProductAndroidConfig] = useState('');
  const [productHistory, setProductHistory] = useState({notes: [], internalNotes: []});
  const [newProductNote, setNewProductNote] = useState({note: ''});
  const notesType = collection === 'facecake' ? 'internalNotes' : 'notes';
  const readOnly = authState?.userPermissions[collection]?.update === false;
  const userEmail = authState?.email;
  const userIsFaceCake = authState.userPermissions.facecake ? true : false;

  // XXX: get the product Android config
  useEffect(() => {
    Storage.get(`p/${collection}/${productSKU}/metadata/android.json`, {
      download: true,
      cacheControl: 'no-cache',
    })
      .then((res) => {
        res.Body.text().then((resText) => {
          setProductAndroidConfig(resText);
        });
      })
      .catch((err) => console.warn(err));
    Storage.get(`p/${collection}/${productSKU}/metadata/history.json`, {
      download: true,
      cacheControl: 'no-cache',
    })
      .then((res) => {
        res.Body.text().then((resText) => {
          setProductHistory(JSON.parse(resText));
        });
      })
      .catch((err) => {
        setProductHistory({ notes: [], internalNotes: [] });
        console.warn(err);
      });
  }, [location, collection, productSKU]);

  const toggleAccordion = (eventKey) => {
    // if toggling currently expanded, set to null so nothing is toggled; otherwise expand new card
    setActiveCard(eventKey === activeCard ? null : eventKey);
  };

  // XXX: general handleChange for normal form fields
  const handleChange = (e) => {
    // const key = e.target.id;
    let value = e.target.value;
    setProductAndroidConfig(value);
  };

  // XXX: save JSON to S3
  const writeJSON = async (object, s3Path, onSuccess) => {
    try {
      await Storage.remove(s3Path);
      const res = await Storage.put(s3Path, JSON.stringify(object, null, 2), {
        level: 'public',
        contentType: 'application/json',
        cacheControl: 'no-cache',
      });
      console.log('Product Android Config Updated:', res?.key);
      onSuccess();
    } catch (err) {
      console.warn('S3 write Error:', err);
      dispatch({
        type: 'danger',
        title: 'Android Config NOT Saved',
        message: `ERROR: ${err}`,
        onConfirm: closeAlert,
      });
    }
  };

  const handleSubmit = () => {
    const productAndroidConfigS3Path = `p/${collection}/${productSKU}/metadata/android.json`;
    writeJSON(JSON.parse(productAndroidConfig), productAndroidConfigS3Path, () =>
      dispatch({
        type: 'success',
        title: 'Android Config Saved',
        message: `Product Android Config saved. Click OK to`,
        onConfirm: () => {
          closeAlert();
          window.location.reload();
        },
      })
    );
  };

  const handleProductNoteChange = (e) => {
    const timestamp = new Date();
    const createdDate = timestamp.toUTCString()
    setNewProductNote({
      note: e.target.value,
      createdDate,
      createdBy: userEmail,
    });
  }

  const handleSaveProductNote = () => {
    if (newProductNote.note === '') {
      dispatch({
        type: 'danger',
        title: 'Note NOT saved.',
        message: `Please enter some text before saving note.`,
        onConfirm: closeAlert,
      });
    } else {
      if (productHistory[notesType]) {
        productHistory[notesType].unshift(newProductNote); // add to top of array
      } else {
        productHistory[notesType] = [newProductNote]; // add to top of array
      }
      const productHistoryS3Path = `p/${collection}/${productSKU}/metadata/history.json`;
      writeJSON(productHistory, productHistoryS3Path, () => {
        setProductHistory(productHistory);
        setNewProductNote({ note: '' });
      });
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col sm={12} md={10} lg={9} xl={8}>
          <Accordion defaultActiveKey="android-config">
            {userIsFaceCake && (
              <Card id="android-config">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="android-config"
                  onClick={() => toggleAccordion('android-config')}
                  style={{
                    backgroundColor:
                      activeCard === 'android-config'
                        ? 'var(--secondary-light)'
                        : 'var(--primary-light)',
                  }}
                >
                  ANDROID CONFIG
                  <div className="float-right">
                    {activeCard === 'android-config' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="android-config">
                  <Card.Body>
                    <Form>
                      <Form.Row>
                        <Form.Group as={Col} controlId="productAndroidConfig">
                          <Form.Label>Config</Form.Label>
                          <Form.Control
                            as="textarea"
                            className="small-text"
                            rows={20}
                            value={productAndroidConfig}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Form.Row>
                      <Form.Row className="mx-auto mb-4 float-left">
                        {/* <Button
                              variant={readOnly ? 'outline-secondary' : 'outline-primary'}
                              disabled={readOnly}
                            >
                              Reset
                            </Button> */}
                        &nbsp;&nbsp;
                        <Button
                          variant={readOnly ? 'secondary' : 'primary'}
                          disabled={readOnly}
                          onClick={handleSubmit}
                        >
                          Save Android Config
                        </Button>
                      </Form.Row>
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
          </Accordion>
        </Col>
        {/* XXX: Try-On col */}
        <Col sm={12} md={12} lg={3} xl={4} className="pl-lg-4">
          <nav aria-label="Product Notes" className="mb-0">
            <ol className="breadcrumb mb-1 pb-1">
              <li className="breadcrumb-item active">
                {notesType === 'internalNotes' && (
                  <strong>INTERNAL&nbsp;</strong>
                )}
                PRODUCT NOTES
              </li>
            </ol>
          </nav>
          <Card className="mb-2">
            <Card.Body className="py-1 px-2">
              <Card.Text>
                <Form.Group as="span" controlId="newProductNote">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={newProductNote.note}
                    onChange={handleProductNoteChange}
                  />
                </Form.Group>
              </Card.Text>
            </Card.Body>
            <Card.Footer className="text-right py-1">
              <span className="float-right mt-0 py-0">
                <Button
                  onClick={handleSaveProductNote}
                  variant="primary"
                  className="py-0"
                >
                  Save Note
                </Button>
              </span>
            </Card.Footer>
          </Card>
          {productHistory[notesType]?.map(
            ({ note, createdDate, createdBy }, i) => (
              <Card key={i} className="my-2">
                <Card.Header className="text-right py-0">
                  <span className="float-left">
                    <small>{createdDate}</small>
                  </span>
                  <span className="float-right">
                    <small>{createdBy}</small>
                  </span>
                </Card.Header>
                <Card.Body className="py-0">
                  <Card.Text>{note}</Card.Text>
                </Card.Body>
              </Card>
            )
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ProductAndroidAssetForm;